/* eslint-disable jira/filename-case */
import pickBy from 'lodash/pickBy';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { TRACK_EVENT_TYPE } from './events.tsx';
import mapAnalyticsDataPayloadToContext from './map-data-payload-to-context-payload.tsx';
import type { FireTrackAnalyticsPayload } from './types.tsx';

const isNotUndefined = <T,>(a: T | undefined): a is T => a !== undefined;

const mapPayload = (payload: FireTrackAnalyticsPayload) => {
	const context = mapAnalyticsDataPayloadToContext(payload);
	const { action, actionSubjectId } = payload;
	return pickBy(
		{
			...context,
			...context.attributes,
			attributes: undefined,
			action,
			actionSubjectId,
		},
		isNotUndefined,
	);
};

export const fireTrackAnalytics = (
	event: UIAnalyticsEvent,
	payload: FireTrackAnalyticsPayload,
): void => {
	event.update({ ...mapPayload(payload), analyticsType: TRACK_EVENT_TYPE }).fire();
};
